import React from 'react';

import { LinkoutCard } from '../../Card';

import { ProjectCardSection, ProjectCardWrapper } from './ProjectCardSection';
import type { LinkoutType } from './hooks';

const ExploreServices = ({
  projectId,
  services,
}: {
  projectId: string;
  services?: LinkoutType[];
}) => {
  if (!services) return null;

  return (
    <>
      <ProjectCardSection>
        {services.map(service => (
          <ProjectCardWrapper key={service.title}>
            <LinkoutCard
              optionalTrackingProperties={{
                track_id: 'services-link-out',
                link_location: 'Services Tile',
                project_id: Number(projectId),
              }}
              {...service}
            />
          </ProjectCardWrapper>
        ))}
      </ProjectCardSection>
    </>
  );
};

export { ExploreServices };
